export const caseDisclaimer = "";
export const caseNote = c => c.note || "";
export const sectors = ["All", "Residential projects", "Business centres", "Ongoing projects"];
export const cases = [
  {
    "slug": "baki-evleri",
    "client": "BAKI EVLƏRİ",
    "sector": "Real Estate",
    "real": true,
    "title": "Turning a residential project into a commercial system that grows in value",
    "year": "",
    "timeframe": "10 months",
    "services": [
      "Brand Strategy",
      "Marketing & Demand Systems",
      "Sales & Commercial Systems"
    ],
    "scope": [
      "Concept & Positioning",
      "Brand Narrative",
      "Marketing & Demand Systems",
      "Performance Marketing",
      "Sales Strategy",
      "Sales Management",
      "Commercial Optimization"
    ],
    "logo": "/experience/baki-evleri-unified.png",
    "cover": "/cases/baki-evleri/aerial.webp",
    "summary": "Positioning, project concept, content, marketing and sales communication were built around the same commercial logic.",
    "context": "YUXEL joined BAKI EVLƏRİ at the start of the project. The brief was never just advertising: it was to define how the development would be received by the market, which story it would be told through, and how the entire commercial chain — from marketing to closed sales — would operate.",
    "challenges": [
      "A new development entering a competitive residential market with no established positioning",
      "Communication built on product specifications rather than a value story buyers could believe in",
      "No structured lead-generation system connecting advertising spend to sales conversations",
      "Marketing and sales operating as separate functions rather than one commercial engine"
    ],
    "approach": [
      {
        "t": "Concept & positioning",
        "d": "A new concept and market position for the project. Communication moved from listing product features to a stronger, buyer-centred value narrative."
      },
      {
        "t": "Marketing & communication system",
        "d": "A full marketing strategy and communication system, with performance advertising and a structured lead-generation engine feeding qualified enquiries to sales."
      },
      {
        "t": "Sales strategy & process",
        "d": "Sales strategy rebuilt and the sales process restructured — clear stages, ownership and follow-up discipline from first enquiry to signed contract."
      },
      {
        "t": "One commercial system",
        "d": "Marketing and sales managed as a single commercial system. The advertising → enquiry → sale → revenue chain was optimised continuously on results."
      }
    ],
    "creative": "Communication was rebuilt around the value story of the development and its residents rather than square metres and specifications. Concept, narrative and creative direction by YUXEL; production assets delivered by our production partner.",
    "impact": [
      {
        "v": "≈40%",
        "l": "Sales price increase in 10 months"
      }
    ],
    "outcome": "Approximately 40% increase in sales price in 10 months",
    "note": "",
    "quote": null,
    "gallery": [
      "/cases/baki-evleri/towers.webp",
      "/cases/baki-evleri/court.webp",
      "/cases/baki-evleri/playground.webp"
    ],
    "result": "Approximately 40% increase in sales price in 10 months"
  },
  {
    "slug": "art-tower",
    "client": "ART TOWER",
    "sector": "Real Estate",
    "real": true,
    "title": "Turning digital planning into a measurable sales channel",
    "year": "",
    "timeframe": "12 months",
    "services": [
      "Marketing & Demand Systems",
      "Business Analytics"
    ],
    "scope": [
      "Digital Strategy",
      "Media Planning",
      "Performance Advertising",
      "Lead Generation",
      "Audience Strategy",
      "Campaign Optimization"
    ],
    "logo": "/experience/art-tower-unified.png",
    "cover": "/cases/art-tower/01.png",
    "summary": "Audience strategy, media planning and enquiry flow supported the sales objective for a premium residential project. YUXEL’s role was digital planning and management of the advertising system.",
    "context": "In premium real estate, digital advertising is usually treated as an enquiry channel: volume in, sales team sorts it out. The brief for ART TOWER was different — turn digital into a performance system that produces sustained, measurable sales on a limited media budget.",
    "challenges": [
      "A premium, high-ticket product with a narrow, discerning buyer audience",
      "Digital advertising judged on enquiry volume rather than sales produced",
      "A limited media budget that had to deliver a continuous sales flow",
      "Campaign decisions disconnected from what actually closed"
    ],
    "approach": [
      {
        "t": "Digital strategy & media plan",
        "d": "A digital advertising strategy and media plan built for ART TOWER — channels, budget split and sequencing decided against sales targets, not reach."
      },
      {
        "t": "Audience segmentation",
        "d": "Buyer segments defined and targeted precisely, with ad structure and creative mapped to each segment's decision path."
      },
      {
        "t": "Quality over volume",
        "d": "The optimisation target moved from enquiry count to the share of enquiries that converted into sales — fewer, better conversations for the sales team."
      },
      {
        "t": "Sales-led optimisation",
        "d": "Budget allocation and campaign optimisation managed continuously on closed-sale data, so spend followed what actually sold."
      }
    ],
    "creative": "Performance creative built for a premium buyer — restrained, specific and consistent across every placement. Strategy, media planning and campaign direction by YUXEL; production assets delivered by our production partner.",
    "impact": [
      {
        "v": "≈60%",
        "l": "Of the project’s apartments sold in 12 months"
      }
    ],
    "outcome": "Approximately 60% of the project’s apartments sold in 12 months",
    "note": "",
    "quote": null,
    "gallery": [
      "/cases/art-tower/01.png",
      "/cases/art-tower/02.png",
      "/cases/art-tower/03.png"
    ],
    "result": "Approximately 60% of the project’s apartments sold in 12 months"
  },
  {
    "slug": "25-plaza",
    "client": "25 PLAZA",
    "sector": "Real Estate",
    "segment": "Commercial Real Estate",
    "real": true,
    "title": "Helping a new business centre reach occupancy quickly",
    "year": "",
    "timeframe": "4 months",
    "services": [
      "Marketing & Demand Systems",
      "Business Analytics"
    ],
    "scope": [
      "Digital Strategy",
      "Media Planning",
      "Performance Advertising",
      "Lead Generation",
      "Audience Strategy",
      "Occupancy Growth"
    ],
    "logo": "/experience/25-plaza-unified.png",
    "cover": "/cases/25-plaza/01.png",
    "summary": "After handover, digital demand, communication and leasing enquiries were aligned around one occupancy objective.",
    "context": "25 Plaza is a five-storey business centre in one of Baku's premium business locations. The brief was commercial and specific: increase demand for the available office space and use digital channels to shorten the leasing process — measured in signed tenancies, not enquiries.",
    "challenges": [
      "Available office stock in a competitive premium business district",
      "A leasing process that needed to move faster than the market default",
      "Corporate decision-makers as the audience — narrow, deliberate and hard to reach",
      "Digital spend that had to be justified by actual leases signed"
    ],
    "approach": [
      {
        "t": "Digital strategy & media plan",
        "d": "A digital advertising strategy and media plan built around leasing targets — channels, budget and sequencing chosen for corporate reach."
      },
      {
        "t": "Corporate audience segmentation",
        "d": "Potential corporate tenants segmented by size, sector and decision path, with messaging mapped to each."
      },
      {
        "t": "Lead-generation system",
        "d": "A structured lead-generation system feeding qualified enquiries to the leasing team, with campaigns managed daily."
      },
      {
        "t": "Quality & occupancy optimisation",
        "d": "Enquiries optimised on quality; digital performance managed against leasing results, not enquiry counts."
      }
    ],
    "creative": "Performance creative built for corporate decision-makers — location, specification and certainty, communicated without noise. Strategy, media planning and campaign direction by YUXEL; production assets delivered by our production partner.",
    "impact": [
      {
        "v": "≈70%",
        "l": "Occupancy within 4 months after handover"
      }
    ],
    "outcome": "Approximately 70% occupancy within 4 months after handover",
    "note": "",
    "quote": null,
    "gallery": [
      "/cases/25-plaza/01.png"
    ],
    "result": "Approximately 70% occupancy within 4 months after handover"
  },
  {
    "slug": "zenith-plaza",
    "client": "ZENITH PLAZA",
    "sector": "Real Estate",
    "segment": "Commercial Real Estate",
    "real": true,
    "title": "Turning digital demand into a sustained flow of leasing enquiries",
    "year": "",
    "timeframe": "10 months",
    "services": [
      "Marketing & Demand Systems",
      "Business Analytics"
    ],
    "scope": [
      "Digital Strategy",
      "Media Planning",
      "Performance Advertising",
      "Lead Generation",
      "Campaign Optimization",
      "Occupancy Growth"
    ],
    "logo": "/experience/zenith-plaza-unified.png",
    "cover": "/cases/zenith-plaza/01.png",
    "summary": "Advertising, enquiry flow and leasing communication were brought together in a measurable system for a seven-storey business centre.",
    "context": "Zenith Plaza is a seven-storey business centre in Baku. The purpose of digital activity was to create sustained demand for the available office space and to connect advertising channels to a real leasing result — not to a growing inbox of unqualified enquiries.",
    "challenges": [
      "Sustained demand needed over a long leasing cycle, not a single launch spike",
      "Corporate audiences that had to be identified and reached precisely",
      "Advertising channels judged on leases signed, not on clicks or enquiries",
      "A lead-generation system to be built and continuously improved"
    ],
    "approach": [
      {
        "t": "Digital strategy & media plan",
        "d": "A digital advertising strategy and media plan for a ten-month leasing cycle — steady, measured and adjusted on results."
      },
      {
        "t": "Corporate audience definition",
        "d": "Corporate audiences identified and targeted, with creative and messaging matched to how tenants choose space."
      },
      {
        "t": "Lead-generation system",
        "d": "A lead-generation system built for the leasing team; campaigns managed and optimised continuously."
      },
      {
        "t": "Enquiry-to-lease improvement",
        "d": "Digital activity refined on the conversion of enquiries into leases — the channel judged as a commercial channel."
      }
    ],
    "creative": "Restrained, specification-led creative for corporate tenants, consistent across every placement over a ten-month cycle. Strategy, media planning and campaign direction by YUXEL; production assets delivered by our production partner.",
    "impact": [
      {
        "v": "≈40–50%",
        "l": "Occupancy in 10 months"
      }
    ],
    "outcome": "Approximately 40–50% occupancy in 10 months",
    "note": "",
    "quote": null,
    "gallery": [
      "/cases/zenith-plaza/01.png",
      "/cases/zenith-plaza/02.png"
    ],
    "result": "Approximately 40–50% occupancy in 10 months"
  },
  {
    "slug": "fexri-tower",
    "client": "FƏXRİ TOWER",
    "sector": "Real Estate",
    "real": true,
    "ongoing": true,
    "title": "Building a digital demand system for a new residential project",
    "year": "",
    "timeframe": "Ongoing",
    "services": [
      "Marketing & Demand Systems"
    ],
    "scope": [
      "Digital Strategy",
      "Media Planning",
      "Performance Advertising",
      "Lead Generation",
      "Campaign Optimization"
    ],
    "logo": "/experience/fexri-tower-unified.png",
    "cover": "/cases/fexri-tower/01.jpg",
    "summary": "At market entry, audience strategy, the digital advertising structure and a sales-oriented flow of enquiries were established.",
    "context": "YUXEL plans and manages FƏXRİ TOWER's digital advertising through its go-to-market phase. Because the project is new, the early focus is precise: identify the right audience, build the digital advertising structure and shape a flow of enquiries that is oriented to sales rather than volume.",
    "challenges": [
      "A new project with no established audience data or market recognition",
      "Digital advertising structure to be built from zero, at market-entry stage",
      "Enquiry flow that has to be sales-oriented from the first campaign",
      "Performance to be proven with a measured, continuously optimised budget"
    ],
    "approach": [
      {
        "t": "Digital advertising strategy",
        "d": "A digital advertising strategy for the market-entry phase — objectives, channels and sequencing defined against the sales plan."
      },
      {
        "t": "Media planning & campaign build",
        "d": "Media plan and campaign architecture built for launch: placements, budget split, creative structure and measurement in place before the first impression."
      },
      {
        "t": "Audience definition & segmentation",
        "d": "Target audiences identified and segmented, with messaging and campaign structure mapped to each segment."
      },
      {
        "t": "Lead generation & optimisation",
        "d": "Lead-generation campaigns managed daily; advertising performance monitored and optimised continuously on enquiry quality."
      }
    ],
    "creative": "Performance creative structured for a launch-phase audience — clear, consistent and built to be tested and refined campaign by campaign. Strategy, media planning and campaign direction by YUXEL; production assets delivered by our production partner.",
    "impact": [
      {
        "v": "Active sales phase",
        "l": ""
      }
    ],
    "outcome": "ACTIVE SALES PHASE",
    "note": "",
    "quote": null,
    "gallery": [
      "/cases/fexri-tower/01.jpg",
      "/cases/fexri-tower/02.jpg",
      "/cases/fexri-tower/03.jpg",
      "/cases/fexri-tower/04.jpg",
      "/cases/fexri-tower/05.jpg",
      "/cases/fexri-tower/06.jpg"
    ],
    "result": "ACTIVE SALES PHASE"
  }
  ,{
    "slug": "cahan-holding", "client": "CAHAN HOLDING", "logo": "/experience/cahan-unified.png", "sector": "Brand & FMCG", "segment": "Selected Experience", "real": true,
    "title": "Brand and product portfolio work across a consumer portfolio", "year": "", "timeframe": "",
    "services": ["Brand Strategy", "Brand Architecture", "Creative Direction"], "scope": ["Brand Strategy", "Portfolio Structure", "Packaging Direction", "Creative Direction"],
    "cover": "/cases/cahan-holding/01.jpg", "summary": "Selected brand and portfolio work completed as part of professional experience prior to YUXEL.",
    "context": "This project belongs to professional experience prior to YUXEL. It is presented here as selected experience rather than as a YUXEL client engagement.",
    "challenges": [], "approach": [], "creative": "Selected work includes brand and product portfolio direction. Only material that can be shown publicly is included.", "impact": [],
    "outcome": "Selected professional experience prior to YUXEL.", "note": "Project contributed to prior to YUXEL.", "quote": null, "gallery": ["/cases/cahan-holding/01.jpg", "/cases/cahan-holding/02.png", "/cases/cahan-holding/03.jpg", "/cases/cahan-holding/04.jpg", "/cases/cahan-holding/05.png"], "result": ""
  },
  {
    "slug": "the-wood", "client": "THE WOOD", "logo": "/experience/the-wood-unified.png", "sector": "Selected Experience", "real": true,
    "title": "Selected professional experience prior to YUXEL", "services": [], "scope": [], "cover": "/experience/the-wood-unified.png",
    "summary": "A project contributed to during professional work prior to YUXEL.", "context": "Included to document selected professional experience. This is not presented as a YUXEL client engagement.",
    "challenges": [], "approach": [], "creative": "", "impact": [], "outcome": "Project contributed to prior to YUXEL.", "note": "Project contributed to prior to YUXEL.", "quote": null, "gallery": [], "result": ""
  },
  {
    "slug": "parla-residence", "client": "PARLA RESIDENCE", "logo": "/experience/parla-residence-unified.png", "sector": "Real Estate", "segment": "Selected Experience", "real": true,
    "title": "Selected professional experience prior to YUXEL", "services": [], "scope": [], "cover": "/experience/parla-residence-unified.png",
    "summary": "A real-estate project contributed to during professional work prior to YUXEL.", "context": "Included to document selected professional experience. This is not presented as a YUXEL client engagement.",
    "challenges": [], "approach": [], "creative": "", "impact": [], "outcome": "Project contributed to prior to YUXEL.", "note": "Project contributed to prior to YUXEL.", "quote": null, "gallery": [], "result": ""
  },
  {
    "slug": "inci-residence", "client": "İNCİ RESIDENCE", "logo": "/experience/inci-residence-unified.png", "sector": "Real Estate", "segment": "Selected Experience", "real": true,
    "title": "Selected professional experience prior to YUXEL", "services": [], "scope": [], "cover": "/experience/inci-residence-unified.png",
    "summary": "A real-estate project contributed to during professional work prior to YUXEL.", "context": "Included to document selected professional experience. This is not presented as a YUXEL client engagement.",
    "challenges": [], "approach": [], "creative": "", "impact": [], "outcome": "Project contributed to prior to YUXEL.", "note": "Project contributed to prior to YUXEL.", "quote": null, "gallery": [], "result": ""
  }
];
export const getCase = slug => cases.find(c=>c.slug===slug);
export const nextCase = slug => cases[(cases.findIndex(c=>c.slug===slug)+1)%cases.length];
